import shorthash from 'shorthash'

// Do not change this function
export default function getReferralCode(userId: number): string {
  const hash1 = shorthash.unique(`user1-${userId}-user1`)
  const hash2 = shorthash.unique(`user2-${userId}-user2`)
  return `u-${hash1}${hash2}`.toUpperCase()
}
